
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import useValidate from "../../store/hooks/useValidator";
import { useDispatch } from "react-redux";
import { callApiAction } from "../../store/actions/commonAction";
import { closeModal } from "../../store/actions/modalAction";
import { SNACK_BAR_VARIETNS } from "../../utils/constants";
import { callSnackBar } from "../../store/actions/snackbarAction";
import CreateQueryUi from "./CreateQueryUi";
import { RepairingTicketCreateApi } from "../../apis/repairing.api";
import { statusActionFilters, statusCountActionFilters } from "../../store/actions/statusAction";
import { FetchProblemApi } from "../../apis/problem.api";
import { fetchNotificationAction } from "../../store/actions/notificationAction";
import { getBoxIdApi } from "../../apis/boxid.api";
import moment from "moment";
import { getProdutApi } from "../../apis/product.api";

const CreateQueryController = ({ statusPass, fieldTicket, setTickets, id }) => {

  const [fields, setFields] = useState({
    _id: "",
    err: "",
    createdAt: fieldTicket?.createdAt ? fieldTicket?.createdAt : "",
    ticket_no: fieldTicket?.ticketNo ? fieldTicket?.ticketNo : "",
    product_id: null,
    box_id: "",
    customer_phone: "",
    customer_name: "",
    customer_email: "",
    source_id: "",
    trakingId: "",
    problems: [],
    solved_in: "",
    customer_address: "",
    other: "",
    status: [],
    manufacturer_date: "",
    country: "",
    state: "",
    city: "",
    is_warranty_3_yr:null
  });
  const [variant1, setVariant] = useState();

  const [loading, setLoading] = useState(false);
  const validate = useValidate();
  const dispatch = useDispatch();
  const title = "Query";

  const validationSchemaForUpdate = useMemo(
    () => [
      {
        required: true,
        value: fields.ticket_no,
        field: "ticket no",
      },
      {
        required: true,
        value: fields.createdAt,
        field: "createdAt",
      },
      {
        required: true,
        value: fields.product_id,
        field: "Product",
      },
      {
        value: fields.customer_email,
        field: "Email",
      },
      {
        required: true,
        value: fields.box_id,
        field: "Box Id",
      },
      {
        required: true,
        value: fields.customer_name,
        field: "Customer Name",
      },
      {
        required: true,
        value: fields.customer_phone?.toString().length === 10 ? true : false,
        field: "Phone",
      },
      {
        required: true,
        value: fields.customer_address,
        field: "Customer Address",
      },
      {
        required: true,
        value: fields.manufacturer_date,
        field: 'Manufacturer Date',
        custom: () => {
          if (moment(fields.manufacturer_date).format("DD/MM/YYYY") === moment().format("DD/MM/YYYY")) {
            return "Manufacturer Date is invalid."
          }
          return true;
        }
      },
      {
        required: true,
        value: fields.source_id,
        field: "Source",
      },
      {
        required: true,
        value: fields.problems.length,
        field: "Problems",
      },
      {
        required: fields?.problems.some((item) => item.toLowerCase() === "other"),
        value: fields.other,
        field: "Other Problem",
      },
      {
        required: true,
        value: fields.solved_in,
        field: "Mode of Query Solving",
      },
      {
        required: true,
        value: fields.country,
        field: "Country",
      },
      {
        required: true,
        value: fields.state,
        field: "State",
      },
      {
        required: true,
        value: fields.city,
        field: "City",
      }
    ],
    [fields]
  );

  const [filters, setFilters] = useState({
    pageNo: 1,
    pageSize: 10,
    search: "",
    searchable: ['name'],
    role: "",
    sort: "createdAt",
    sortDirection: -1,
  })

  const [boxId, setBoxId] = useState();

  const [filtersBoxId, setFiltersBoxId] = useState({
    pageNo: 1,
    pageSize: 10,
    search: "",
    sort: "createdAt",
    sortDirection: -1,
  });

  const onSubmit = async (e) => {
    e.preventDefault();
    const validationResponse = validate(validationSchemaForUpdate)
    if (validationResponse === true) {
      setLoading(true)
      dispatch(callApiAction(
        async () => await RepairingTicketCreateApi({ ...fields, product_id: fields.product_id._id ? fields.product_id._id : fields.product_id, source_id: fields.source_id._id ? fields.source_id._id : fields.source_id }),
        (response) => {
          setLoading(false)
          dispatch(fetchNotificationAction());
          dispatch(callSnackBar("Query Created Successfully", SNACK_BAR_VARIETNS.suceess));
          dispatch(closeModal("Query"))
          dispatch(statusActionFilters(filters));
          dispatch(statusCountActionFilters(-1));
        }, (err) => {
          setLoading(false);
          setFields({ ...fields, err });
        }
      ))
    } else {
      setFields({ ...fields, err: validationResponse })
      setLoading(false)
    }
  };

  const [listProblem, setlistProblem] = useState()
  const [product, setProduct] = useState()
  const fetchList = useCallback(() => {
    dispatch(
      callApiAction(
        async () => await getProdutApi({ ...filters }),
        (response) => {
          setProduct(response?.result)
        },
        (err) => {
          console.log("Error", err)
        }
      )
    );
  }, [dispatch, filters])
  const FetchBoxId = useCallback(() => {
    dispatch(
      callApiAction(
        async () => await getBoxIdApi({ ...filtersBoxId, searchable: ["boxId", "sold.cphone"] }),
        (response) => {
          if (response?.result?.length < 1) {
          } else {
            setBoxId(response?.result?.map((item) => ({
              boxId: item?.new_box_id ? item?.new_box_id : item?.box_id ? item?.box_id : item.boxId,
              _id: item._id,
              customer_phone: item?.customer_phone ? item?.customer_phone : item.beneficiary_id ? item.beneficiary_id?.phone : item.sold?.cphone || "",
              customer_email: item?.customer_email ? item?.customer_email : item.beneficiary_id ? item.beneficiary_id?.email : item.sold?.cemail || "",
              customer_name: item?.customer_name ? item?.customer_name : item.beneficiary_id ? item.beneficiary_id?.name : item.sold?.cname || "",
              customer_address: item?.customer_address ? item?.customer_address : item.beneficiary_id ? item.beneficiary_id?.addres_line : item.sold?.caddress || "",
              band_box_id: item?.band_box_id ? item?.band_box_id : item.convertedProducts?.[0] || "",
              country: item?.beneficiary_id ? item?.beneficiary_id?.country?.name : item?.country || "",
              state: item?.beneficiary_id ? item?.beneficiary_id?.state?.name : item?.state || "",
              city: item?.beneficiary_id ? item?.beneficiary_id?.taluka?.name : item?.city || "",
              product_id: {
                _id: item?.product_id?._id ?? "",
                name: item?.product_id?.name ?? ""
              },
              source_id: {
                _id: item?.source_id?._id ?? "",
                title: item?.source_id?.title ?? ""
              },
              manufacturer_date: item?.manufacturer_date ?? moment(),
              problems: item?.problems?.length > 0 ? item?.problems : [],
              other: item?.other ? item?.other : ""
            }))
            );
          }
        },
        (err) => {
          console.log("Error", err)
        }
      )
    );
  }, [dispatch, filtersBoxId])

  useEffect(() => {
    fetchList();
  }, [filters, fetchList])

  useEffect(() => {
    if (fields.product_id?._id && fields.product_id?.name) {
      const matchedProduct = product?.find((item) => item?._id === fields?.product_id?._id);
      if (matchedProduct) {
        setlistProblem(matchedProduct.problems || []);
      }
    }
  }, [fields?.product_id?._id])

  useEffect(() => {
    // const timeoutId = setTimeout(() => {
    if (filtersBoxId.search) {
      FetchBoxId();
    } else {
      FetchBoxId();
    }
    // }, 500);
    // return () => clearTimeout(timeoutId);
  }, [filtersBoxId.search, FetchBoxId,])

  return (
    <CreateQueryUi
      listProblem={listProblem}
      title={title}
      loading={loading}
      fields={fields}
      onSubmit={onSubmit}
      setFields={setFields}
      variant1={variant1}
      setVariant={setVariant}
      BoxIDAutoCompleted={boxId}
      setFiltersBoxId={setFiltersBoxId}
      filtersBoxId={filtersBoxId}
      product={product}
      setFilters={setFilters}
      filters={filters}
      setlistProblem={setlistProblem}
    />
  );
};
export default memo(CreateQueryController);
